import { IsArray, IsNull, Values } from "@pdfking/tfunc"

import { is_element } from "./is_element"
import { is_function } from "./is_function"
import { is_iterator } from "./is_iterator"
import { is_object } from "./is_object"

/**
 * Converts value(s) to array.
 *
 * Handles arrays, objects, iterators, primitives, null/undefined.
 * Multiple args are flattened into single array.
 *
 * @param args - Value(s) to convert
 * @returns Array
 *
 * @example
 * ```ts
 * import { to_array } from "@pdfking/rfunc"
 *
 * to_array([1, 2]) // [1, 2]
 * to_array({ a: 1, b: 2 }) // [1, 2]
 * to_array(5) // [5]
 * to_array(null) // []
 * to_array(1, 2, 3) // [1, 2, 3]
 * ```
 */
const _to_array = iterable => {
  if (IsArray(iterable)) {
    return iterable
  }
  if (is_iterator(iterable)) {
    const array = []
    for (let value of iterable) {
      array.push(value)
    }
    return array
  }
  if (is_function(iterable) || is_element(iterable)) {
    return [iterable]
  }
  if (is_object(iterable)) {
    return Values(iterable)
  }
  if (IsNull(iterable)) {
    return []
  }
  return [iterable]
}

export const to_array = (...args) => {
  if (args.length == 1) {
    return _to_array(args[0])
  }
  return _to_array(args).reduce((a, b) => a.concat(_to_array(b)), [])
}
